import { render } from "./ProductConfiguratorField.vue?vue&type=template&id=4a44aa35"
import script from "./ProductConfiguratorField.vue?vue&type=script&lang=js"
export * from "./ProductConfiguratorField.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__